export enum ToastMessages {
  ERROR = "Oups ! Une erreur est survenue.",
  ERROR_RETRY = "Une erreur est survenue. Merci de réessayer ultérieurement.",
  ERROR_UPDATE = ERROR_RETRY,
  ERROR_NOT_FOUND = "Nous n'avons pas trouvé la ressource à laquelle vous essayez d'accéder.",
  ERROR_FORBIDDEN = "Vous n'avez pas les droits nécessaires pour accéder à cette ressource.",
  ERROR_INTERNAL_SERVER_ERROR = ERROR,
  ERROR_FORM_VALIDATION = "Merci de renseigner tous les champs obligatoires (marqués d'une étoile *) et de corriger les erreurs de validation.",
  ERROR_PERIMETRES_FETCH = "Une erreur est survenue lors de la récupération des périmètres. Certaines fonctionnalités peuvent être dégradées.",

  CONTACT_METIER_CREATION_SUCCESS = "Le contact métier a bien été créé",
  CONTACT_METIER_BATCH_CREATION_SUCCESS = "Les contacts métiers ont bien été créés",
  CONTACT_METIER_DELETE_SUCCESS = "Le contact métier a bien été supprimé",
  CONTACT_METIER_EDIT_SUCCESS = "Le contact métier a bien été édité",
}
